import {
    createApp
} from 'vue'
import App from './App.vue'
import axios from 'axios';
import AppConfig from '../appconfig';
import * as Sentry from '@sentry/vue';

axios.defaults.baseURL = AppConfig.baseUrl;

const app = createApp(App);

Sentry.init({
    app,
    dsn: "https://096053b0f39f447d9fa414251d006e21@o480006.ingest.sentry.io/5625620",
    tracesSampleRate: 1.0
});

app.mount('#app');